module.exports = __webpack_public_path__ + "img/domicile-2.cadd63fc.jpg";